import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const BirthdayAttackHMACModule = () => (
  <QPhototModuleSubtopic
    title="Birthday Attack, HMAC"
    videos={[
      "https://www.youtube.com/embed/Kt4U0OmOM48",
      "https://www.youtube.com/embed/sxWxCtJ3og0"
    ]}
    takeaways={[
      {
        text:
          "Practice at least one HMAC problem thoroughly and copy the complete worked solution into your notebook for CAT-2."
      },
      
    ]}
    questions={[
      {
        text:
          "HMAC is used for message authentication in a banking system. If an attacker can observe the HMAC output but not the key:\n(i) Can they forge a valid message? Justify.\n(ii) How does HMAC resist preimage attacks?"
      },
      {
        text:
          "Assume a security system uses the SHA-01 hash function. Using the birthday paradox, estimate the approximate number of random hashes required to have a 50% probability of finding a collision."
      },
      {
        text:
          "Suppose in the HMAC algorithm, the message M = \"Hello\" and the key K = \"Hi\". Find out the ‘Si’ and ‘So’ based on the hex conversion of ASCII characters where the length of the hash code ‘n’ is 4 bits. Also, convert the ‘Si’ and ‘So’ sizes in terms of the MD5 variant.",
          image: "/cns_8.png"
      },
      {
        text:
          "How do HMAC and digital signatures ensure message integrity and authentication? Compare their working principles, security guarantees, and real-world applications. Additionally, analyse why digital signatures provide non-repudiation while HMAC does not."
      },
      {
        text:
          "Explain in detail the birthday paradox’s impact on digital signatures and hash functions using all possible relevant examples or scenarios."
      },
      {
        text:
          "Determine the number of padding bits, total length, and number of blocks used in HMAC for the hash functions SHA-512 and MD5 if the input message to be sent is M = 1011011100011110 and the key K = 10111011."
      }
    ]}
    exampleVideos={[]}
  />
);

export default BirthdayAttackHMACModule;
